<template>
  <v-avatar :size="size" :color="color">
    <span class="white--text font-600" :style="{fontSize : `${textSize}px`}">{{ text }}</span>
  </v-avatar>
</template>
<script>
export default {
  name: 'avatar',
  props: {
    size: {
      type: String,
      default: '36'
    },
    color: {
      type: String,
      default: '#58e2c2'
    },
    text: {
      type: String,
      required: true
    },
    textSize: {
      type: String,
      default: '16'
    }
  }
};
</script>
